// extracted by mini-css-extract-plugin
export default {"questionSetIndex":"styles__questionSetIndex___fLWwS"};